import { FC, Fragment } from 'react';
import { BrokerSpecificComponentsProps } from '../../types.type';
import { BROKERS } from 'v3/common/constants';
import PortalToTarget from 'v3/common/components/PortalToTarget';
import IIFL from './Brokers/IIFL';
import AcAgarwal from './Brokers/AcAgarwal';
import Bonanza from './Brokers/Bonanza';
import IndiraSecurities from './Brokers/IndiraSecurities';
import JainamBroking from './Brokers/JainamBroking';
import kasat from './Brokers/Kasat';
import Kbs from './Brokers/Kbs';
import PhilipCapital from './Brokers/PhilipCapital';
import Tradeplus from './Brokers/Tradeplus';
import KotakNeo from './Brokers/KotakNeo';
import Religare from './Brokers/Religare';
import TradeSmart from './Brokers/TradeSmart';
import Finvasia from './Brokers/Finvasia';
import Profitmart from './Brokers/Profitmart';
import SkyBroking from './Brokers/SkyBroking';
import Zebull from './Brokers/Zebull';
import Paytm from './Brokers/Paytm';
import FlatTrade from './Brokers/FlatTrade';
import Rupeezy from './Brokers/Rupeezy';
import Sharekhan from './Brokers/Sharekhan';
import FairInvest from './Brokers/FairInvest';
import Samco from './Brokers/Samco';
import Zerodha from './Brokers/Zerodha';
import CoinDcx from './Brokers/CoinDcx';
import Investright from './Brokers/Investright';
import HdfcSky from './Brokers/HdfcSky';
import { useLoginContext } from '../../LoginProvider';
import { useUserValidation } from '../useUserValidation';
import Aliceblue from './Brokers/Aliceblue';
import FivePaisa from './Brokers/Fivepaisa';
import Upstox from './Brokers/Upstox';
import Fyers from './Brokers/fyers';
import AngleBroking from './Brokers/AngelBroking';

const brokerComponents: Record<string, FC<BrokerSpecificComponentsProps>> = {
  [BROKERS.ac_agarwal.id]: AcAgarwal,
  [BROKERS.bonanza.id]: Bonanza,
  [BROKERS.iifl.id]: IIFL,
  [BROKERS.indira_securities.id]: IndiraSecurities,
  [BROKERS.jainam_broking.id]: JainamBroking,
  [BROKERS.kasat.id]: kasat,
  [BROKERS.kbs.id]: Kbs,
  [BROKERS.philip_capital.id]: PhilipCapital,
  [BROKERS.zebull.id]: Zebull,
  [BROKERS.tradeplus.id]: Tradeplus,
  [BROKERS.paytm.id]: Paytm,
  [BROKERS.flattrade.id]: FlatTrade,
  [BROKERS.rupeezy.id]: Rupeezy,
  [BROKERS.sharekhan.id]: Sharekhan,
  [BROKERS.fair_invest.id]: FairInvest,
  [BROKERS.zerodha.id]: Zerodha,
  [BROKERS.coin_dcx.id]: CoinDcx,
  [BROKERS.invest_right.id]: Investright,
  [BROKERS.hdfcsky.id]: HdfcSky,
  [BROKERS.fivepaisa.id]: FivePaisa,
  [BROKERS.upstox.id]: Upstox,
  // OTP based brokers
  [BROKERS.kotak_neo.id]: KotakNeo,
  [BROKERS.religare.id]: Religare,
  [BROKERS.trade_smart.id]: TradeSmart,
  // TOTP based brokers
  [BROKERS.finvasia.id]: Finvasia,
  [BROKERS.profitmart.id]: Profitmart,
  [BROKERS.sky_broking.id]: SkyBroking,
  [BROKERS.samco.id]: Samco,
  [BROKERS.aliceblue.id]: Aliceblue,
  [BROKERS.fyers.id]: Fyers,
  [BROKERS.angel_broking.id]: AngleBroking,
};

const AuthComponents: FC = () => {
  const {
    switchPage,
    state: { selectedBrokerConfig },
  } = useLoginContext();

  const { brokerSpecificHandles, userValidaitionState } = useUserValidation({ selectedBrokerConfig });

  const renderBrokerSpecificContent = () => {
    const BrokerComponent = selectedBrokerConfig?.id ? brokerComponents[selectedBrokerConfig?.id] : null;

    return BrokerComponent ? (
      <BrokerComponent
        userConfigs={userValidaitionState}
        brokerSpecificHandles={brokerSpecificHandles}
        switchPage={switchPage}
      />
    ) : null;
  };

  return (
    <Fragment>
      <PortalToTarget targetClassName="login-modal__header" allowForWeb className="broker-specific__modal">
        <img src={selectedBrokerConfig?.image} alt={`${selectedBrokerConfig?.name} logo`} />
      </PortalToTarget>
      {renderBrokerSpecificContent()}
    </Fragment>
  );
};

export default AuthComponents;
